import { Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { FormGroup } from '@angular/forms';
import { AgreementForm } from '../../../shared-agreement.model';
import { RiskAnalysis } from 'app/features/agreement/components/risk-analysis/risk-analysis.component';

@UntilDestroy()
@Component({
    selector: 'app-agreement-risk-analysis',
    templateUrl: './agreement-risk-analysis.component.html',
    styleUrl: './agreement-risk-analysis.component.scss'
})
export class AgreementRiskAnalysisComponent {
    @Input() public agreementForm: FormGroup<AgreementForm>;

    public get detailsForm() {
        return this.agreementForm.controls.details;
    }

    public get f() {
        return this.agreementForm.controls;
    }

    public get riskAnalysis(): RiskAnalysis {
        if (!this.detailsForm.controls.riskAnalysis.value) {
            return null;
        }
        return JSON.parse(this.detailsForm.controls.riskAnalysis.value) as RiskAnalysis;
    }
}
